import { ScheduledEvent } from "types";
import { GetUserLoadAPI } from "types/userManagement/userManagementInterface";

export const isEventTypeEV = (eventType: ScheduledEvent.EventType) => {
  return eventType === ScheduledEvent.EventType.EV_CPE;
};

export const triggerGoogleSpacesAPI = async (
  message: string,
  webhookUrl: string
) => {
  try {
    const response = await fetch(webhookUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        text: `${message}`,
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    console.log("Message posted successfully:", data);
  } catch (error) {
    console.error("Error posting message:", error);
  }
};

export const getGSPACE_WEBHOOKURL = (eventType: ScheduledEvent.EventType) => {
    let webhookUrl =
      "https://chat.googleapis.com/v1/spaces/AAAAQAjSDkY/messages?key=AIzaSyDdI0hCZtE6vySjMm-WEfRq3CPzqKqqsHI&token=VmRD853DiPUqmBWEs3tutLqmsOW1Z7JOpV2Tfn5D9Ug";
  
    switch (eventType) {
      case ScheduledEvent.EventType.EV_CPE:
        webhookUrl =
          "https://chat.googleapis.com/v1/spaces/AAAAjwl96xA/messages?key=AIzaSyDdI0hCZtE6vySjMm-WEfRq3CPzqKqqsHI&token=m0DgalFQT6OEo9KA1iLE1jLxhkbOafjr06mWt8d6ndY";
        return webhookUrl;
      default:
        return webhookUrl;
    }
  };

export const formatOngageUserCountData= (data : GetUserLoadAPI.retval) => {
    console.log(data);
    const unSubscribedUsers = Number(data?.unsubscribed || 0) + Number(data?.complaint || 0);
    const activeUsers = Number(data?.active || 0) + Number(data?.bounced || 0);
    
    return {
      activeUsers: activeUsers,
      unsubscribed: unSubscribedUsers
    };
  }